module.exports = __webpack_public_path__ + "static/media/Icon_Eislaufhilfe.7839196c.png";